interface MobileMenuElements {
  toggle: HTMLElement | null;
  menu: HTMLElement | null;
  backdrop: HTMLElement | null;
  closeBtn: HTMLElement | null;
  body: HTMLElement | null;
}

class MobileMenuManager {
  private elements: MobileMenuElements;
  private isInitialized: boolean = false;

  constructor() {
    this.elements = {
      toggle: document.querySelector('.site-header-mobile-menu-toggle'),
      menu: document.querySelector('.site-header-mobile-menu'),
      backdrop: document.querySelector('.site-header-mobile-menu-backdrop'),
      closeBtn: document.querySelector('.mobile-menu-close-btn'),
      body: document.body
    };
  }

  /**
   * Initialize mobile menu functionality
   */
  init(): void {
    if (this.isInitialized || !this.areElementsPresent()) {
      return;
    }

    this.bindEvents();
    this.isInitialized = true;
    console.log('Mobile menu initialized');
  }

  /**
   * Check if required DOM elements exist
   */
  private areElementsPresent(): boolean {
    return !!(
      this.elements.toggle &&
      this.elements.menu &&
      this.elements.backdrop
    );
  }

  /**
   * Bind event listeners to menu elements
   */
  private bindEvents(): void {
    // Toggle button click
    this.elements.toggle?.addEventListener('click', () => this.toggle());

    // Backdrop click
    this.elements.backdrop?.addEventListener('click', () => this.close());

    // Close button click
    this.elements.closeBtn?.addEventListener('click', () => this.close());

    // Escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.elements.menu?.classList.contains('active')) {
        this.close();
      }
    });

    // Close on link click
    document.querySelectorAll('.site-header-mobile-nav-link').forEach((link) => {
      link.addEventListener('click', () => this.close());
    });
  }

  /**
   * Toggle menu visibility
   */
  toggle(): void {
    if (!this.areElementsPresent()) return;

    const { menu, backdrop, toggle, body } = this.elements;
    const isOpen = menu?.classList.toggle('active');

    backdrop?.classList.toggle('active');
    toggle?.classList.toggle('active');
    body?.classList.toggle('menu-open');

    if (isOpen) {
      body!.style.overflow = 'hidden';
    } else {
      body!.style.overflow = '';
    }
  }

  /**
   * Close the mobile menu
   */
  close(): void {
    if (!this.areElementsPresent()) return;

    const { menu, backdrop, toggle, body } = this.elements;

    menu?.classList.remove('active');
    backdrop?.classList.remove('active');
    toggle?.classList.remove('active');
    body?.classList.remove('menu-open');
    body!.style.overflow = '';
  }

  /**
   * Check if menu is currently open
   */
  isOpen(): boolean {
    return this.elements.menu?.classList.contains('active') ?? false;
  }
}

// Export singleton instance
export const mobileMenu = new MobileMenuManager();

// Auto-initialize on DOMContentLoaded
if (typeof window !== 'undefined') {
  document.addEventListener('DOMContentLoaded', () => {
    mobileMenu.init();
  });
}
